module.exports = __webpack_public_path__ + "static/media/waxing.dee6e0f2.svg";